/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A single CVE finding for a specific image digest, including all image refs that resolve to that digest.
 */
export type VulnerabilityGroupItem = {
  /**
   * Immutable image digest.
   */
  imageDigest: string;
  /**
   * Image references observed for this digest within the query scope.
   */
  imageRefs: Array<string>;
  /**
   * Severity of this CVE for this digest.
   */
  severity: VulnerabilityGroupItem.severity;
  /**
   * CVSS base score when available.
   */
  cvssScore?: number;
  /**
   * Vendor advisory identifier when available.
   */
  advisoryId?: string;
  /**
   * Name of the advisory issuer (e.g. Red Hat, NVD) when known.
   */
  issuer?: string;
  /**
   * URL to the CVE details page. Points to Red Hat Security portal for Red Hat advisories, otherwise to NVD.
   */
  link?: string;
  /**
   * Short summary of the vulnerability.
   */
  description?: string;
  /**
   * Advisory publish time when known.
   */
  publishedAt?: string;
  /**
   * Number of devices in scope running this digest.
   */
  affectedDevices?: number;
  /**
   * When this CVE was first observed in this digest.
   */
  firstSeenAt?: string;
};
export namespace VulnerabilityGroupItem {
  /**
   * Severity of this CVE for this digest.
   */
  export enum severity {
    CRITICAL = 'Critical',
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
    NONE = 'None',
    UNKNOWN = 'Unknown',
  }
}

